/**
 * contract Group
 * @param fb : FormBuilder
 */
export function contractGroup(fb: any): any {
    return fb.group(
        {
            reference: fb.control(''),
            isActive: fb.control([]),
            type: fb.control([]),
            includeNoJourney: fb.control(''),
        });

}
